/* Copyright (c) Trimble Inc. All rights reserved. */
import React, { useEffect } from "react";
import GenericPageTitle from "modus/components/generic-page-title/GenericPageTitle";
import { Box } from "@material-ui/core";
import { Breadcrumbs } from "modus/components/generic-page-title/Breadcrumbs";
import { NotificationList } from "../components/NotificationList";


export const NotificationDiscoveryPage:React.FC = () => {

   
    return (
        <Box> 
            <Breadcrumbs 
                pageTitle={`Notifications`}/>   
            <GenericPageTitle
                title={"Notifications"}
                noSkeleton
            />
            <NotificationList />
        </Box>
    )
};

export default NotificationDiscoveryPage;
